//引入提示组件
import { Message } from 'element-ui'
import router from '@/router'

/***************************公共方法类***************************/
const utils = {

  /**
   * 数据列表转树形结构
   * @param datas 数据
   * @param option 参数:
   *        id: ID字段
   *        parentId: 父级ID字段
   *        children: 子节点字段
   *        sort: 排序的字段(排序仅针对根节点,其他的数据通过列表排序)
   *        asc: 是否升序
   */
  convertTree: function (datas, option) {
    //参数继承
    let options = $.extend({
      id: 'id',
      parentId: 'parentId',
      children: 'children',
      sort: 'sort',
      asc: true
    }, option)

    let trees = []
    //数据处理
    if (!datas) {
      return trees
    }

    //数据分组(key: 父级ID, value: [数据])
    let groups = {}, map = {}
    datas.forEach(node => {
      //创建列表ID索引
      map[node[options.id]] = node
      //按父级ID分组
      let parentId = node[options.parentId]
      if (!groups.hasOwnProperty(parentId)) {
        groups[parentId] = []
      }
      groups[parentId].push(node)
    })

    //找出数据的根节点（父级ID为空、有父节点值但是找不到父节点的数据或者父级点等于本身的ID）
    $.each(groups, function (key, node) {
      if (!map.hasOwnProperty(key)) {
        //没有找到父级
        trees = trees.concat(node)
        delete groups[key]
      }
      else if(node.length == 1 && key == node[0][options.id]){
        //找到父级但是父级是自身
        trees = trees.concat(node)
        delete groups[key]
      }
    })
    //根节点排序(Object的会自动根据key排序,所以此处需要单独处理)
    let sort = options.sort
    if (sort) {
      trees.sort(function (a, b) {
        return options.asc ? a[sort] - b[sort] : b[sort] - a[sort]
      })
    }

    //子节点添加
    this.appendChildren(trees, groups, options)
    return trees
  },

  /**
   * 添加子节点
   * @param roots 根节点
   * @param groups 分组数据
   * @param options 参数
   */
  appendChildren: function (roots, groups, options) {
    if (!$.isEmptyObject(groups)) {
      roots.forEach(root => {
        if (groups.hasOwnProperty(root[options.id])) {
          root[options.children] = groups[root[options.id]]
          delete groups[root[options.id]]
          //递归下级子节点
          this.appendChildren(root[options.children], groups, options)
        }
      })
    }
  },

  /**
   * 下载文件
   * @param response 响应文件流
   * @param name 下载文件名
   */
  downloadFile: function(response, name){
    //判断返回类型（如果返回json,下载失败）
    if(response.data.type === 'application/json'){
      //下载失败处理
      let reader = new FileReader()
      reader.addEventListener('loadend', () => {
        try {
          const { message } = JSON.parse(reader.result)
          Message.error(message || '下载失败')
        } catch (e) {
          Message.error('下载失败')
        }
      })
      reader.readAsText(response.data, 'utf-8')
      return
    }
    // 提取文件名
    const filename = name ? name : response.headers['content-disposition'].match(/filename=(.*)/)[1]
    // 将二进制流转为blob
    const blob = new Blob([response.data], { type: 'application/octet-stream' })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
      window.navigator.msSaveBlob(blob, filename)
    } else {
      // 创建新的URL并指向File对象或者Blob对象的地址
      const blobURL = window.URL.createObjectURL(blob)
      // 创建a标签，用于跳转至下载链接
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', filename)
      // 兼容：某些浏览器不支持HTML5的download属性
      if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank')
      }
      // 挂载a标签
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      // 释放blob URL地址
      //window.URL.revokeObjectURL(blobURL)
    }
  },

  /**
   * 格式化时间
   * @param date 日期时间
   * @param fmt 格式
   */
  formatDate: function(date, fmt){
    let o = {
      'M+': date.getMonth() + 1,                    //月份
      'd+': date.getDate(),                         //日
      'H+': date.getHours(),                        //小时
      'm+': date.getMinutes(),                      //分
      's+': date.getSeconds(),                      //秒
      'q+': Math.floor((date.getMonth() + 3) / 3),  //季度
      'S': date.getMilliseconds()                   //毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },

  /**
   * 文件转BASE64编码
   * @param file 文件
   */
  toBase64: function(file){
    return new Promise((resolve, reject) => {
      if(file && file.raw){
        let reader = new FileReader()
        reader.readAsDataURL(file.raw)
        //成功回调
        reader.onloadend = e => resolve(e)
        //失败回调
        reader.onerror = e => reject(e)
      } else {
        //文件不存在
        reject()
      }
    })
  },

  /**
   * 获取当前登录用户
   */
  getUserInfo() {
    let user = sessionStorage.getItem('user')
    if (!user) {
      router.push('/login')
    }
    try {
      return JSON.parse(user)
    } catch (err) {}
  }

}

export default utils



// WEBPACK FOOTER //
// ./src/js/utils.js